module.exports = __webpack_public_path__ + "388ee6e647fed9ea2cd261a893d5954e.jpg";